import numeral from "numeral";

export const centerShortenLongString = (string, maxLength) => {
	if(typeof string === 'string') {
		if(string.length > maxLength) {
			let charCountForRemoval = string.length - maxLength;
			let stringHalfwayPoint = Math.floor(maxLength/2);
			string = string.slice(0, stringHalfwayPoint) + "..." + string.slice(stringHalfwayPoint + charCountForRemoval, string.length);
			return string;
		}else{
			return string;
		}
	}else{
		return '';
	}
}

export const APP_CONFIG_ALL_ENVS = {
 "development": {
  cryptoEscrowMeetingLink: "https://meetings.hubspot.com/dev123/coinbase-quest",
	cryptoEscrowFormLink: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/89a63983-e81a-466a-aa3a-8e7df23e3acb",
	cryptoEscrowFormLinkWithStateSharer: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/bb67f5ee-173c-44f7-8c69-231421426923",
	cryptoEscrowFormLinkWithStateReceiver: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/50671a4f-2cef-4e61-b9f5-6e36c9901345",
	newsletterFormLink: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/eb35dd26-1b37-4ef9-bcd6-45138290e548",
	recaptchaKey: process.env.GATSBY_APP_RECAPTCHA_KEY ? process.env.GATSBY_APP_RECAPTCHA_KEY : "",
	googleAnalyticsKey: "G-M6GP1JP970",
	apiUrl: "https://stage.api.propy.com/api/v3",
 },
 "production": {
  cryptoEscrowMeetingLink: "https://meetings.hubspot.com/eric-l-cruz/cb-quest",
	cryptoEscrowFormLink: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/aaf57d0f-2d60-442f-9496-d832b9c77d45",
	cryptoEscrowFormLinkWithStateSharer: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/bb67f5ee-173c-44f7-8c69-231421426923",
	cryptoEscrowFormLinkWithStateReceiver: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/50671a4f-2cef-4e61-b9f5-6e36c9901345",
	newsletterFormLink: "https://api.hsforms.com/submissions/v3/integration/submit/4204561/eb35dd26-1b37-4ef9-bcd6-45138290e548",
	recaptchaKey: process.env.GATSBY_APP_RECAPTCHA_KEY ? process.env.GATSBY_APP_RECAPTCHA_KEY : "",
	googleAnalyticsKey: "G-14VBKHN7GY",
	apiUrl: "https://api.propy.com/api/v3",
 }
}

export const APP_CONFIG = APP_CONFIG_ALL_ENVS[process.env.GATSBY_ENV];

export const PROD_APP_CONFIG = APP_CONFIG_ALL_ENVS["production"];

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const PROPY_LIGHT_GREY = "#f6f6f6";

export const PROPY_LIGHT_BLUE = "#38A6FB";

export const PROPY_BLUE = "#38a6fa";
export const PROPY_BLUE_DARK = "#007BDA";

export const IS_GLOBAL_TOP_BANNER_ENABLED = false;
export const GLOBAL_TOP_BANNER_HEIGHT = 28;
export const GLOBAL_PAGE_HEIGHT = IS_GLOBAL_TOP_BANNER_ENABLED ? `calc(100vh - ${64 + GLOBAL_TOP_BANNER_HEIGHT}px)` : 'calc(100vh - 64px)';

export function extractPropertyLotSize(data, returnType) {
	let result = {
		value: Math.floor(data?.value),
		label: "",
	}
	if(data?.type === 1) {
		result.label = "ft²"
	}
	if(returnType) {
		return result[returnType]
	}
	return result
}

const getDynamicFormat = (currentFormat = '0,0.00', number) => {
	let requestedDecimals = 0;
	let preDecimalFormat;
	let postDecimalFormat;
	if(currentFormat.split(".").length > 0) {
			requestedDecimals = currentFormat.split(".")[1].length;
			postDecimalFormat = currentFormat.split(".")[1];
			preDecimalFormat = currentFormat.split(".")[0];
	}
	let currentFormattedNumber = numeral(number).format(currentFormat).toString();
	let currentFormattedDecimals = '';
	if(currentFormattedNumber.split('.') && currentFormattedNumber.split('.')[1]) {
			currentFormattedDecimals = currentFormattedNumber.split('.')[1];
	}
	let currentUnformattedDecimals = '';
	if(number.toString().split(".").length > 0 && number.toString().split(".")[1]) {
			currentUnformattedDecimals = number.toString().split(".")[1];
	}
	let dynamicFormat = currentFormat;
	if((currentFormattedDecimals.replace(/[^1-9]/g,"").length < requestedDecimals) && (currentUnformattedDecimals.replace(/[^1-9]/g,"").length >= requestedDecimals)) {
			let indexOfSignificantFigureAchievement = 0;
			let significantFiguresEncountered = 0;
			let numberString = number.toString();
			let numberStringPostDecimal = "";
			if(numberString.split(".").length > 0) {
					numberStringPostDecimal = numberString.split(".")[1]
			}
			for(let i = 0; i < numberStringPostDecimal.length; i++) {
					// @ts-ignore
					if((numberStringPostDecimal[i] * 1) > 0) {
							significantFiguresEncountered++;
							if(significantFiguresEncountered === requestedDecimals) {
									indexOfSignificantFigureAchievement = i + 1;
							}
					}
			}
			if(indexOfSignificantFigureAchievement > requestedDecimals) {
					let requestedDecimalsToSignificantFiguresDelta = indexOfSignificantFigureAchievement - requestedDecimals;
					dynamicFormat = preDecimalFormat + ".";
					if(postDecimalFormat) {
							dynamicFormat = preDecimalFormat + "." + postDecimalFormat;
					}
					for(let i = 0; i < requestedDecimalsToSignificantFiguresDelta; i++) {
							dynamicFormat = dynamicFormat + "0";
					}
			}
	}
	return dynamicFormat;
}

export const priceFormat = (number, decimals = 2, currency = "$", prefix = true) => {
	let decimalString = "";
	for(let i = 0; i < decimals; i++){
			decimalString += "0";
	}
	if (currency.length > 1) {
			prefix = false;
	}
	let format = '0,0.' + decimalString;
	if(Number(number) < 10) {
			format = getDynamicFormat(format, number);
	}
	let result = numeral(number).format(format);
	if(result === 'NaN') {
		result = '0.00';
	}
	if (prefix) {
			return `${currency}${'\u00A0'}`+ result;
	} else {
			return result + `${'\u00A0'}${currency}`
	}
}

export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";SameSite=Strict;path=/";
}

export const getCookieValue = (name) => (
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
)

export const uuid = () => {
	/*eslint-disable */
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
	/*eslint-enable */
}

export const trackCustomEvent = ({
  category,
  action,
  label,
  value
}) => {
	try {
		if (typeof window !== 'undefined' && window.gtag) {
			window.gtag('event', action, {
				event_category: category,
				event_label: label,
				value: value
			})
			
			if (process.env.GATSBY_ENV === 'development') {
				console.log('Event tracked:', {
					category,
					action,
					label,
					value
				})
			}
		}
	} catch (e) {
		console.log("Error tracking event");
	}
}

export const getRandomElement = (array) => {
	if (!array || array.length === 0) {
			return null;
	}
	return array[Math.floor(Math.random() * array.length)];
}